import ContentPage, { Section } from "./ContentPage";
import { ABOUT } from "../data/legal";

export default function About() {
  return (
    <ContentPage title={ABOUT.title} lead={ABOUT.lead}>
      {ABOUT.sections.map((section) => (
        <Section
          key={section.heading}
          heading={section.heading}
          body={section.body}
          items={section.items}
        />
      ))}
    </ContentPage>
  );
}
